const accessoryTypes = {
    CREATE_ACCESSORY_ACTION: "CREATE_ACCESSORY_ACTION",
    GET_LIST_ACCESSORY_ACTION: "GET_LIST_ACCESSORY_ACTION",
    GET_LIST_ALL_ACCESSORY_ACTION: "GET_LIST_ALL_ACCESSORY_ACTION",
    GET_DETAIL_ACCESSORY_ACTION: "GET_DETAIL_ACCESSORY_ACTION",
    UPDATE_ACCESSORY_ACTION: "UPDATE_ACCESSORY_ACTION",
    CREATE_ACCESSORY_SUCCESS: "CREATE_ACCESSORY_SUCCESS",
    GET_LIST_ACCESSORY_SUCCESS: "GET_LIST_ACCESSORY_SUCCESS",
    GET_LIST_ALL_ACCESSORY_SUCCESS: "GET_LIST_ALL_ACCESSORY_SUCCESS",
    GET_DETAIL_ACCESSORY_SUCCESS: "GET_DETAIL_ACCESSORY_SUCCESS",
    UPDATE_ACCESSORY_SUCCESS: "UPDATE_ACCESSORY_SUCCESS",
    CREATE_ACCESSORY_FAILED: "CREATE_ACCESSORY_FAILED",
    GET_LIST_ALL_ACCESSORY_FAILED: "GET_LIST_ALL_ACCESSORY_FAILED",
    GET_LIST_ACCESSORY_FAILED: "GET_LIST_ACCESSORY_FAILED",
    GET_DETAIL_ACCESSORY_FAILED: "GET_DETAIL_ACCESSORY_FAILED",
    UPDATE_ACCESSORY_FAILED: "UPDATE_ACCESSORY_FAILED"
}

export default accessoryTypes;